import _extends from "@babel/runtime/helpers/extends";

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import { Stack } from './Stack';
var HStack = /*#__PURE__*/React.forwardRef(function HStack(props, ref) {
  return /*#__PURE__*/React.createElement(Stack, _extends({}, props, {
    ref: ref,
    orientation: "horizontal"
  }));
});
var VStack = /*#__PURE__*/React.forwardRef(function VStack(props, ref) {
  return /*#__PURE__*/React.createElement(Stack, _extends({}, props, {
    ref: ref,
    orientation: "vertical"
  }));
});
export { HStack, Stack, VStack };